import { UserMenuItem } from "interface/userMenuItem";
import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { PageAccessByMenu } from "interface/user";
import { PageTypePath } from "utils/pages";

export async function getMenuApi() {
    const apiUri = "/menu/get";

    try {
        const menuResponse = await AxiosApi.get<ApiResponse<UserMenuItem[]>>(apiUri, {})
        return menuResponse.data.data
    } catch (error) {
        throw error
    }
}

export async function getPageAccessApi(menuId: number) {
    const apiUri = "/menu/PageAccess";

    try {
        const menuResponse = await AxiosApi.get<ApiResponse<PageAccessByMenu>>(apiUri, {params:{
            menuId: menuId
        }})
        return menuResponse.data.data
    } catch (error) {
        throw error
    }
}

export async function getHomePageItemAccessApi() {
    const apiUri = "/menu/HomePageItemAccess";
    const relatedPaths = [PageTypePath.RegistrationList, PageTypePath.SalesNotesList, PageTypePath.LandingNoteList, PageTypePath.Home];
    
    try {
        // Create URLSearchParams to handle multiple values for same parameter
        const params = new URLSearchParams();
        relatedPaths.forEach(path => params.append('paths', path));
        
        const menuResponse = await AxiosApi.get<ApiResponse<PageAccessByMenu[]>>(`${apiUri}?${params.toString()}`)
        return menuResponse.data.data
    } catch (error) {
        throw error
    }
}
